import { styled } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import colors from "../../../../assets/theme/base/colors";

const { primary } = colors;

const StyledDataGrid = styled(DataGrid)
({
    "& .MuiDataGrid-columnHeaderTitleContainer": {
        justifyContent: "center"
    },
    "& .MuiDataGrid-columnHeaders": { 
        backgroundColor: "#2F444B"
    },
    "& .MuiDataGrid-columnHeaderTitle": { 
        color: "white ", 
        textAlign: "center", 
        whiteSpace: "pre-line", 
        lineHeight: "1.1"
    },
    "& .MuiDataGrid-cell": { 
        justifyContent: "center", 
        minHeight: "30px"
    },
    "& .MuiDataGrid-main": { 
        fontSize: 14,        
    },
    "& .left-align-cell": { 
        justifyContent: "flex-start" 
    },
    "& .spacer-row": { 
        fontWeight: "400",
        color: "white",
        lineHeight: "1.6",
        backgroundColor: primary.main
    },
    "& .spacer-row:hover": { 
        fontWeight: "400",
        color: "white",
        lineHeight: "1.6",
        backgroundColor: primary.main
    },
    "& .value-row": { 
        lineHeight: "2.5" ,
    },
    "& .greyed-out-cell": { 
        backgroundColor: "#f0f0f0"
    },
    "& .negative-variance": {
        fontWeight: "400",
        backgroundColor: "#fcd3d0",
        color: "red"
    },
    "& .positive-variance": {
        fontWeight: "400",
        backgroundColor : "#ffd59f",
        color: "#c87000"
    },
    "& .zero-variance": {
        fontWeight: "400",
        backgroundColor: "#bce2be",
        color: "green"
    },
    "& .hideRightSeparator > .MuiDataGrid-columnSeparator" : {
      display: 'none',
    },
    "& .clickable-cell" : {
        cursor: "pointer",
        textDecoration: "underline",
    }
});

export default StyledDataGrid;
